import { OktaAuth } from '@okta/okta-auth-js';
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { SummarySales, SummaryShare, SummaryMedia, SummaryDCP, Segment } from './../../types';
import { Params } from '../../types';
/* eslint-disable no-async-promise-executor */
import { fetchCall } from '../../services/api';
import { store } from '../../redux/store';
import { tokenHasExpired } from '../../helpers/auth';

/**
 * Returns container height based on external UI factors
 * @param containerHeight
 * @returns {Number}
 */
export const returnContainerHeight = (containerHeight: number): number => {
  // set height maximum for UI purposes
  if (window.innerHeight > 1200) return 750;
  const navigationHeight = 56; // statically set Navigation.styled.ts
  const filterHeight = 60; // statically set on ui.styled.ts

  return containerHeight - (navigationHeight + filterHeight) - 50;
};

/**
 * Returns overview segment card heights based on native
 * device factors
 * @param cHeight
 * @param isLandscape
 * @returns {number}
 */
export const returnCardHeight = (cHeight: number, isLandscape: boolean): number => {
  const containerHeight = returnContainerHeight(cHeight);
  // evaluate default/snapshot height based on tablet landscape view
  const defaultHeight = isLandscape ? 3.5 : 3.8;

  return containerHeight / defaultHeight;
};

/**
 * Handles total overview data fetching and aggregation
 * @param marketFilters
 * @param dateFilters
 * @returns {Promise<SummaryData>} promise value with summary data
 */

export async function fetchSales(params: Params): Promise<SummarySales> {
  const api = store.getState().config.react_app_api_base_url;

  return new Promise(async (resolve, reject) => {
    try {
      resolve(await fetchCall(`${api}/summary/sales`, params));
    } catch (error) {
      console.error(error);
      reject('Error fetching sales overview data. Please try again.');
    }
  });
}

export async function fetchNetSales(params: Params): Promise<Segment> {
  const api = store.getState().config.react_app_api_base_url;

  return new Promise(async (resolve, reject) => {
    try {
      resolve(await fetchCall(`${api}/atglance/sales/summary`, params));
    } catch (error) {
      console.error(error);
      reject('Error fetching sales overview data. Please try again.');
    }
  });
}

export async function fetchShare(params: Params): Promise<SummaryShare> {
  const api = store.getState().config.react_app_api_base_url;

  return new Promise(async (resolve, reject) => {
    try {
      resolve(await fetchCall(`${api}/summary/share/amazon`, params));
    } catch (error) {
      console.error(error);
      reject('Error fetching share amazon overview data. Please try again.');
    }
  });
}
export async function fetchShareCompetitive(params: Params): Promise<SummaryShare> {
  const api = store.getState().config.react_app_api_base_url;

  return new Promise(async (resolve, reject) => {
    try {
      resolve(await fetchCall(`${api}/summary/share/competitive/sales`, params));
    } catch (error) {
      console.error(error);
      reject('Error fetching share competitive overview data. Please try again.');
    }
  });
}
export async function fetchDcp(params: Params): Promise<SummaryDCP> {
  const api = store.getState().config.react_app_api_base_url;

  return new Promise(async (resolve, reject) => {
    try {
      resolve(await fetchCall(`${api}/summary/penetration`, params));
    } catch (error) {
      console.error(error);
      reject('Error fetching DCP overview data. Please try again.');
      // reject();
    }
  });
}
export async function fetchMedia(params: Params, oktaAuth: OktaAuth): Promise<SummaryMedia> {
  const api = store.getState().config.react_app_api_base_url;

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetchCall(`${api}/summary/media`, params);
      oktaAuth?.tokenManager.get('idToken').then((idToken) => {
        if (Date.now() + 3600 * 1000 - idToken.expiresAt * 1000 > 60000) {
          tokenHasExpired(200, oktaAuth);
        }
      });
      resolve(response);
    } catch (error) {
      console.error(error);
      if ((error as any)?.response.status == 401) tokenHasExpired((error as any)?.response.status, oktaAuth);
      reject('Error fetching media overview data. Please try again.');
    }
  });
}
export async function fetchSpgr(params: Params): Promise<any> {
  const api = store.getState().config.react_app_api_base_url;

  return new Promise(async (resolve, reject) => {
    try {
      resolve(await fetchCall(`${api}/summary/media/spgr`, params));
    } catch (error) {
      console.error(error);
      reject('Error fetching SPGR data. Please try again.');
    }
  });
}

/**
 * Checks if object argument has all null properties
 * @param object
 * @returns
 */
export const hasAllNullProperties = (object: any): boolean => {
  return Object.values(object).every((x) => x === null);
};

export const isEmpty = (object: any): boolean => {
  if (object !== null) {
    return Object.keys(object).length === 0;
  } else {
    return true;
  }
};

export async function fetchDigitalShelf(params: Params): Promise<any> {
  const api = store.getState().config.react_app_api_base_url;

  return new Promise(async (resolve, reject) => {
    try {
      resolve(await fetchCall(`${api}/summary/digitalshelf`, params));
    } catch (error) {
      console.error(error);
      reject('Error fetching Digital Shelf data. Please try again.');
    }
  });
}
